import { environment } from '@customer-portal/environments';

import { SidebarGroup } from '../models';

export const SIDEBAR_MENU_GROUP_LIST: SidebarGroup[] = [
  {
    id: 'group1',
    items: [
      {
        i18nKey: 'overview.title',
        icon: 'home',
        id: 'id-overview',
        isDisabled: false,
        url: '/overview',
      },
    ],
  },
  {
    id: 'group2',
    items: [
      {
        i18nKey: 'contracts.title',
        icon: 'custom-file-check',
        id: 'id-contracts',
        isDisabled: false,
        url: '/contracts',
      },
      {
        i18nKey: 'schedule.title',
        icon: 'calendar',
        id: 'id-schedule',
        isDisabled: false,
        url: '/schedule',
      },
      {
        i18nKey: 'audits.title',
        icon: 'custom-clipboard-edit',
        id: 'id-audits',
        isDisabled: false,
        url: '/audits',
      },
      {
        i18nKey: 'findings.title',
        icon: 'custom-clipboard-results',
        id: 'id-findings',
        isDisabled: false,
        url: '/findings',
      },
      {
        i18nKey: 'financials.title',
        icon: 'money-bill',
        id: 'id-financials',
        isDisabled: false,
        url: '/financials',
      },
      {
        i18nKey: 'certificates.title',
        icon: 'custom-certified',
        id: 'id-certificates',
        isDisabled: false,
        url: '/certificates',
      },
    ],
  },
  {
    id: 'group3',
    items: [
      {
        i18nKey: 'trainings.title',
        icon: 'graduation-cap',
        id: 'id-trainings',
        isDisabled: false,
        url: '/trainings',
        externalUrl: environment.lmsUrl,
      },
      {
        i18nKey: 'apps.title',
        icon: 'th-large',
        id: 'id-apps',
        isDisabled: false,
        url: '/apps',
      },
    ],
  },
];
